module.exports = __webpack_public_path__ + "static/media/slashLogo.197f7b9e.png";